import React from 'react';
import Modal from './Modal';
import Button from './Button';

interface IOSInstallModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const IOSInstallModal: React.FC<IOSInstallModalProps> = ({
  isOpen,
  onClose,
}) => {
  const steps = [
    {
      icon: '📱',
      title: 'Open Safari',
      description:
        "Make sure you're using Safari browser on your iPhone or iPad.",
    },
    {
      icon: '⎋',
      title: 'Tap Share Button',
      description:
        'Tap the share button (square with arrow pointing up) at the bottom of the screen.',
    },
    {
      icon: '🏠',
      title: 'Add to Home Screen',
      description:
        'Scroll down and tap "Add to Home Screen" from the share menu.',
    },
    {
      icon: '✅',
      title: 'Confirm Installation',
      description:
        'Tap "Add" to confirm. Riddl will now appear on your home screen!',
    },
  ];

  return (
    <Modal isOpen={isOpen} onClose={onClose} title='Install Riddl on iOS'>
      <div className='space-y-6'>
        <div className='text-center'>
          <p className='text-gray-600 dark:text-gray-300 mb-4'>
            Follow these steps to add Riddl to your home screen for the best
            experience:
          </p>
        </div>

        <div className='space-y-4'>
          {steps.map((step, index) => (
            <div key={index} className='flex items-start space-x-4'>
              <div className='flex-shrink-0 w-12 h-12 bg-teal-100 dark:bg-teal-900 rounded-full flex items-center justify-center'>
                <span className='text-2xl'>{step.icon}</span>
              </div>
              <div className='flex-1'>
                <h3 className='font-semibold text-gray-900 dark:text-white'>
                  {index + 1}. {step.title}
                </h3>
                <p className='text-sm text-gray-600 dark:text-gray-300 mt-1'>
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className='bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg p-4'>
          <div className='flex items-start space-x-3'>
            <span className='text-blue-600 dark:text-blue-400 text-lg'>💡</span>
            <div>
              <p className='text-sm font-medium text-blue-900 dark:text-blue-100'>
                Pro Tip
              </p>
              <p className='text-sm text-blue-700 dark:text-blue-300 mt-1'>
                Once installed, Riddl will work offline and feel like a native
                app. You'll get daily notifications and the best gaming
                experience!
              </p>
            </div>
          </div>
        </div>

        <div className='flex justify-end space-x-3 pt-4'>
          <Button variant='secondary' onClick={onClose}>
            Got It
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default IOSInstallModal;
